import { render, staticRenderFns } from "./ProjectListing.vue?vue&type=template&id=535fc706&scoped=true"
import script from "./ProjectListing.vue?vue&type=script&lang=js"
export * from "./ProjectListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535fc706",
  null
  
)

export default component.exports